<template>
    <div>
        <div id="header-container" class="pl-5">
            <img :src="`${publicPath}/img/gep/bg-header.svg`" class="img-header">
            <div class="pt-4 text-white">
                <h3 class="text-white">{{ $t('Accounts') }}</h3>
                <span class="fz-16 fw-400">Manage and access all your accounts here.</span>
            </div>
        </div>
        <b-container fluid class="mt-0 pb-5">
            <div id="body-container">
                <b-row>
                    <b-col xl="12">
                        <div class="p-0 pb-5">
                            <h3 class="pl-3 pt-3">{{ $t('Sub Account') }}</h3>
                            <hr>
                            <!-- <a href="account-opening" class="btn btn-primary text-white mb-4 mt-3">+Create Account</a> -->
                            <SubAccountList
                            @sub-account = "viewDetail"
                            ></SubAccountList>
                        </div>
                    </b-col>
                </b-row>
            </div>
      </b-container>
      <b-modal id="modal-detail-subaccount" class="p-0" size="md" hide-footer hide-header-close>
            <img :src="`${publicPath}/img/gep/icon/details.svg`" width="100px" class="ml-auto mr-auto d-block details-icon">
            <div class="text-center fz-16 fw-600 text-grey7 mb-1">Details</div>
            <div class="text-center fz-28 fw-600 mb-4">Lorem Ipsum</div>
            <hr class="dashed">
            <b-row>
                <b-col cols="12">
                    <table class="table-rounded w-100">
                        <tr>
                            <td class="p-2 text-grey7 fw-500">Account Name</td>
                            <td class="px-3 text-center">:</td>
                            <td class="px-3 fw-600 text-right" style="max-width: 220px;">{{ current_data.bankAccountName }}</td>
                        </tr>
                        <tr>
                            <td class="p-2 text-grey7 fw-500">Bank Name</td>
                            <td class="px-3 text-center">:</td>
                            <td class="px-3 fw-600 text-right" style="max-width: 220px;">{{ current_data.bankName }}</td>
                        </tr>
                        <tr>
                            <td class="p-2 text-grey7 fw-500">Bank No</td>
                            <td class="px-3 text-center">:</td>
                            <td class="px-3 fw-600 text-right" style="max-width: 220px;">{{ current_data.bankNo }}</td>
                        </tr>
                        <tr>
                            <td class="p-2 text-grey7 fw-500">Branch Code</td>
                            <td class="px-3 text-center">:</td>
                            <td class="px-3 fw-600 text-right" style="max-width: 220px;">{{ current_data.bankSubCode }}</td>
                        </tr>
                        <tr>
                            <td class="p-2 text-grey7 fw-500">Bank Address</td>
                            <td class="px-3 text-center">:</td>
                            <td class="px-3 fw-600 text-right" style="max-width: 220px;">{{ current_data.bankAddress }}</td>
                        </tr>
                        <tr>
                            <td class="p-2 text-grey7 fw-500">Swift Code</td>
                            <td class="px-3 text-center">:</td>
                            <td class="px-3 fw-600 text-right" style="max-width: 220px;">{{ current_data.swiftCode }}</td>
                        </tr>
                    </table>
                </b-col>
            </b-row>
            <hr class="dashed">
            <button class="btn btn-primary mt-3 w-100" @click="$bvModal.hide('modal-detail-subaccount')">Close</button>
        </b-modal>
      <LoaderComponent v-if="isLoading"></LoaderComponent>
    </div>
  </template>
  <script>
  
    import LoaderComponent from "@/components/LoaderComponent";
    import SubAccountList from "@/components/SubAccountList";
    import CreateAccount from '@/services/CreateAccount';

    export default {
        name: 'account-opening',
        data() {
            return {
                publicPath :process.env.BASE_URL!='/'?process.env.BASE_URL:'',
                isLoading : false,
                current_data:{}
            }
        },
        components: {
            LoaderComponent,
            SubAccountList
        },
        methods:{
            viewDetail(data){
                this.current_data = data;
                    this.$router.push({ 
                    path: '/detail-account',
                    query: data
                });
            },
            checkError(err){
                try{
                    this.isLoading = false;
                    const response = err.response;  
                    if(response.status == 400){
                        if(typeof response.data.message === 'string'){
                            this.$notify({
                                type: 'warn',
                                text: response.data.message
                            });
                        }
                        else{
                            if(response.data.message['errorMsg']){
                                this.$notify({
                                    type: 'warn',
                                    text: response.data.message['errorMsg']
                                });
                            }
                            else{
                                let ret = [];
                                Object.keys(response.data.message).forEach((key) => {
                                    ret.push(response.data.message[key][0]);
                                });

                                this.$notify({
                                    type: 'warn',
                                    html: ret.join("<br>")
                                });
                            }
                        }
                    }      
                    else if(response.status == 401 && response.data.name == "Unauthorized"){
                            localStorage.removeItem("token");
                            localStorage.removeItem("member");
                            localStorage.removeItem("isFirstTime");
                            this.$router.push({ 
                                path: '/login', 
                            });
                    }
                    else{
                        if(localStorage.getItem("token")){
                            var msg = (response.data)?response.data.message:err.message;
                            this.$notify({
                                type: 'warn',
                                text: msg
                            })
                        }
                    }
                }catch(e){
                    console.log(err);
                }
            },
            doSubmit(){
                CreateAccount.createSubAccount(this.current_data.id).then(response => {
                    const data = response.data.data;
                    this.$bvModal.hide('modal-create-subaccount');
                }).catch(err => {
                    this.$bvModal.hide('modal-create-subaccount');
                    this.checkError(err);
                });
            },
            createSubAccount(data){
                this.current_data = data;
                this.$bvModal.show('modal-create-subaccount');
            }
        },
        mounted(){
        }
    };
  </script>

<style>
.dashed{
    border-top: 2px dashed #D1D4D7;
}
.details-icon{
    background: #EDF8F1;
    border-radius: 20px;
    margin-bottom: 15px;
}
#modal-detail-subaccount .modal-body{
    padding-top: 0 !important;
}
</style>
